<div class="section-header">
  <div class="section-title">
    <h3>{{ title }}</h3>
    <button (click)="refresh()" mat-icon-button><mat-icon>refresh</mat-icon></button>
  </div>
  <div class="section-actions">
    <mat-slide-toggle
      [checked]="onlyEvaluators"
      (change)="toggleOnlyEvaluators($event.checked)"
    >
      {{ 'AI_ASSISTANT.TESTING.TEST_CASES.FILTER_ONLY_EVALUATORS' | translate }}
    </mat-slide-toggle>
    <button mat-stroked-button [matMenuTriggerFor]="actionsMenu">
      {{ 'AI_ASSISTANT.TESTING.TEST_CASES.ACTIONS' | translate }}
      <mat-icon>arrow_drop_down</mat-icon>
    </button>
    <mat-menu #actionsMenu="matMenu">
      <button mat-menu-item (click)="editTestCase(null)">
        <mat-icon>add</mat-icon>
        {{ 'AI_ASSISTANT.TESTING.TEST_CASES.CREATE' | translate }}
      </button>
      <button mat-menu-item (click)="generateTestCases.emit()">
        <mat-icon>auto_awesome</mat-icon>
        {{ 'AI_ASSISTANT.TESTING.GENERATE_TEST_CASES' | translate }}
      </button>
      <button mat-menu-item (click)="uploadTestCases.emit()">
        <mat-icon>upload</mat-icon>
        {{ 'AI_ASSISTANT.TESTING.UPLOAD_TEST_CASES' | translate }}
      </button>
      <button mat-menu-item (click)="openEvaluateSourceModal()">
        <mat-icon>fact_check</mat-icon>
        @if (isVoice) {
          {{ 'AI_ASSISTANT.TESTING.TEST_CASES.EVALUATE_CALL_RECORD' | translate }}
        } @else {
          {{ 'AI_ASSISTANT.TESTING.TEST_CASES.EVALUATE_CONVERSATION' | translate }}
        }
      </button>
    </mat-menu>
    <button mat-raised-button color="primary" (click)="configureTestRun.emit()">
      <mat-icon>play_arrow</mat-icon>
      {{ 'AI_ASSISTANT.TESTING.CONFIGURE_TEST_RUN' | translate }}
    </button>
  </div>
</div>
<glxy-table-container
  class="simple-table"
  [dataSource]="dataSource"
  [columns]="columns"
  [pageSizeOptions]="[10, 20, 30]"
  [pageSize]="10"
  [border]="false"
  [fullWidth]="false"
  (selectionChanged)="selectionChanged($event)"
>
  <glxy-table-content-header showFilters="false" showFiltersButton="false" showSort="false">
    <button mat-menu-item (click)="runSelectedTests()">
      {{ 'AI_ASSISTANT.TESTING.TEST_CASES.RUN_SELECTED' | translate }}
    </button>
  </glxy-table-content-header>
  <table mat-table matSort (matSortChange)="sortData($event)">
    <tr mat-header-row *matHeaderRowDef="[]"></tr>

    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <glxy-table-selection />
      </th>
      <td mat-cell *matCellDef="let row">
        <glxy-table-selection [row]="row" />
      </td>
    </ng-container>

    <ng-container matColumnDef="evaluator">
      <th mat-header-cell *matHeaderCellDef class="evaluator-col"></th>
      <td mat-cell *matCellDef="let element" class="evaluator-col">
        @if (element.isSuccessEvaluator) {
          <mat-icon
            class="evaluator-icon"
            inline="true"
            [glxyTooltip]="'AI_ASSISTANT.TESTING.TEST_CASES.SUCCESS_EVALUATOR_BADGE' | translate"
          >
            fact_check
          </mat-icon>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'AI_ASSISTANT.TESTING.TEST_CASES.NAME' | translate }}
      </th>
      <td mat-cell *matCellDef="let element">{{ element.name }}</td>
    </ng-container>

    <ng-container matColumnDef="prompt">
      <th mat-header-cell *matHeaderCellDef>{{ 'AI_ASSISTANT.TESTING.TEST_CASES.PROMPT' | translate }}</th>
      <td mat-cell *matCellDef="let element">
        @if (isVoice) {
          {{ element.callerInstructions }}
        } @else if (element.chatHistory?.length === 1) {
          {{ element.chatHistory[0].content }}
        } @else if (element.chatHistory?.length > 1) {
          {{ 'AI_ASSISTANT.TESTING.TEST_CASES.MULTIPLE' | translate }}
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="expectation">
      <th mat-header-cell *matHeaderCellDef>{{ 'AI_ASSISTANT.TESTING.TEST_CASES.EXPECTATION' | translate }}</th>
      <td mat-cell *matCellDef="let element">{{ element.expectation }}</td>
    </ng-container>

    <ng-container matColumnDef="agentArchitecture">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'AI_ASSISTANT.TESTING.TEST_CASES.AGENT_ARCHITECTURE' | translate }}
      </th>
      <td mat-cell *matCellDef="let element">
        {{ getAgentArchitectureName(element.agentArchitecture) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button (click)="editTestCase(element)" mat-icon-button>
          <mat-icon>edit</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button (click)="deleteTestCase(element)" mat-icon-button>
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-row *matRowDef="let row; columns: []"></tr>
  </table>
</glxy-table-container>
